"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MainLayout = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
exports.MainLayout = ({ children }) => {
    return React.createElement("main", { className: 'clp-main' }, children);
};
//# sourceMappingURL=MainLayout.js.map